export enum PlotType {
  Stacked = 'Stacked',
  CumulativeStacked = 'CumulativeStacked',
  Line = 'Line',
  CumulativeLine = 'CumulativeLine',
}
